function getForm(wfConfig, formId) {
  return wfConfig.formsById?.[formId];
}
export {
  getForm
};
//# sourceMappingURL=controller-props.js.map
